
export const DAILY_WARM_TIPS: string[] = [
"今天只要比昨天好一點點，就值得你對自己點頭。",
"你不用把所有事都想清楚，先把下一步走出去就好。",
"累了就停一下，別把休息當成罪惡感。",
"慢也沒關係，你正在往前，這就很了不起。",
"今天先完成一件小事，勝過想完一百件大事。",
"把心放回當下：現在能做什麼，就做什麼。",
"你不是沒用，你只是需要一點時間。",
"能撐到現在的你，本身就是答案的一部分。",
"如果今天很難，就把目標縮小到「撐過今天」。",
"情緒很吵沒關係，先照顧身體：喝水、深呼吸、站起來。",
"你不需要討好所有人，先把自己照顧好。",
"再小的進度都是進度，不要看輕它。",
"你正在學會一種新的生活方式：更溫柔地對自己。",
"不是每件事都要立刻解決，有些事放一晚就會變清楚。",
"你可以不完美，但你一直在努力，這很珍貴。",
"當你覺得不行的時候，先做「最小可行」的那一步。",
"別急著贏，先別輸給放棄。",
"今天的你，已經做得夠多了。",
"你不是落後，你只是在走自己的節奏。",
"把自己當朋友說話，你會更有力氣。",
"你走到這裡不是運氣，是韌性。",
"如果心裡很亂，就先把桌面整理一下，世界會安靜一點。",
"你不需要一次證明自己，日子會慢慢替你證明。",
"有些路看起來慢，是因為你走得很踏實。",
"你正在變強，只是你還不習慣那種感覺。",
"今天先不要求快，先要求穩。",
"當你願意再試一次，你就已經贏了。",
"你可以害怕，但你仍然能前進。",
"別把自己逼到角落，留一點空氣給明天。",
"把注意力放在可控的：一封信、一通電話、一段文字。",
"你不是一個人，你只是暫時需要一點陪伴。",
"今天先把自己找回來，事情會跟著回到軌道。",
"你不用撐得很漂亮，撐住就好。",
"你做不到的不是永遠，只是今天。",
"慢慢來是很高級的能力。",
"你值得被理解，也值得被善待。",
"今天如果只能做到六成，也請你給自己掌聲。",
"把壓力當成提醒：你在乎，但不必獨扛。",
"你可以選擇溫柔，而不是硬撐。",
"每一次回來，都算重新開始。",
"別跟別人的高光比，你有你的路線圖。",
"如果你很累，先把自己放在第一順位。",
"你可以暫停，但不要否定自己。",
"今天先做一件會讓你呼吸順一點的事。",
"你不是卡住，你是在蓄力。",
"把大事拆小，你會發現其實沒那麼可怕。",
"你還在這裡，就代表你很勇敢。",
"你不需要一直堅強，你可以柔軟也很有力量。",
"今天先做一件「對自己好」的選擇。",
"你不是失敗，你只是需要換方法。",
"焦慮來的時候，先把肩膀放下來。",
"你不用一次到位，你只要一直在路上。",
"不想動也沒關係，先動一分鐘就好。",
"今天先完成，再優化；先上岸，再游得漂亮。",
"你可以把今天當作練習，不必考滿分。",
"你正在變成你需要的那個人。",
"把呼吸放慢，你會更清楚自己要什麼。",
"你已經做得比你以為的更多了。",
"今天先把心安頓好，事情才會聽話。",
"你可以脆弱，但你不會因此變小。",
"你可以求助，這不是麻煩，是成熟。",
"今天先把一件事收尾，就很棒。",
"你不必證明自己值得，你本來就值得。",
"不順利不代表你走錯，只是路在考驗耐心。",
"你可以慢慢學，不用一次就會。",
"你不是停滯，你是在整理。",
"今天先把自己放回安全感裡。",
"你不需要跟時間打架，跟自己站在同一邊就好。",
"你可以把標準調成「可完成」而不是「完美」。",
"今天先讓自己好過一點，再談其他。",
"你可以把困難說出來，它就會小一點。",
"你正在建立新的底氣。",
"你不必一直勇敢，你只要不放棄。",
"你值得擁有比較輕的日子。",
"今天先把心裡的石頭放下來一顆。",
"你不是被困住，你是在找出口。",
"你可以重新開始很多次，這叫韌性。",
"今天先照顧好自己，世界不會因此崩壞。",
"你已經撐過很多次了，這次也會。",
"別急著責怪自己，先理解自己。",
"你不需要「都做到」，你只要「做一些」。",
"今天先把情緒抱一下，再往前走。",
"你可以難過，但你不會被難過定義。",
"你正在累積一種很稀有的能力：持續。",
"如果你覺得喘，先把步伐放慢。",
"今天先完成最重要的那一點點。",
"你不是不夠好，你只是很累。",
"把今天當成過渡站，不是終點站。",
"你可以不確定，但你仍然能行動。",
"你會好的，不是因為運氣，是因為你一直沒放棄。",
"今天先把自己安頓好，再去安頓事情。",
"你不需要一直輸出，允許自己充電。",
"你可以把壓力拆成小份慢慢吃掉。",
"今天先做一件能讓你安心的事。",
"別急著追趕，先把腳步踩穩。",
"你可以不擅長，但你可以學。",
"你正在走一條更成熟的路。",
"你已經比昨天更靠近了。",
"今天先跟自己說：辛苦了。",
"你值得一個溫柔的晚上。",
"你不需要一直扛，你可以放下。",
"今天先做一件「讓明天更輕鬆」的事。",
"你可以害怕，但你不孤單。",
"你不是退步，你是在恢復。",
"今天先把心裡的噪音關小一點。",
"你已經很努力了，請不要再打擊自己。",
"你可以不快樂，但你仍然值得被愛。",
"今天先把自己照亮一點點。",
"你可以慢慢來，世界不會跑掉。",
"你做不到，只是需要多一點時間。",
"今天先把最簡單的那一步做完。",
"你不用一次到達，你只要持續靠近。",
"你不是在浪費時間，你是在打底。",
"今天先允許自己不完美。",
"你可以選擇先保護自己的心。",
"今天先把能量留給最重要的人：你。",
"你已經很棒了，真的。",
"今天先把一件事做好，其他先不管。",
"你可以先完成，再把它變漂亮。",
"你不是一事無成，你只是走得很踏實。",
"今天先把重點放回自己。",
"你可以休息，休息不是放棄。",
"你值得被溫柔對待，包括你自己。",
"今天先讓自己站穩，再去跑。",
"你不需要硬撐，你可以靠近支持。",
"今天先把心放軟一點。",
"你可以慢，但你一直在走。",
"你不是不行，你只是太久沒好好呼吸。",
"今天先讓自己過得更像自己。",
"你已經很勇敢了，別忘了這件事。",
"今天先做一件會讓你微笑的事。",
"你可以把困難留到明天再想。",
"你正在變得更成熟、更溫柔、更強大。",
"今天先把自己抱緊一點。",
"你可以重新整理，不用急著結論。",
"今天先把事情做完 80%，就很厲害。",
"你值得被相信，也值得相信自己。",
"今天先把一個小角落收拾乾淨。",
"你不是在逃避，你是在調整。",
"今天先把心安頓，再把事完成。",
"你可以不完美，但你一直在努力。",
"今天先把自己從自責裡拉出來。",
"你會越來越好，因為你一直在學。",
"今天先做一件能讓你安心的選擇。",
"你不是孤軍奮戰，你只是還沒遇到懂你的人。",
"今天先把自己照顧好，其他再說。",
"你可以慢慢長大，慢慢變好。",
"今天先把壓力放到桌上，不要放在胸口。",
"你已經很了不起了，真的。",
"今天先把最重要的那一口氣吸進來。",
"你可以把今天當成重新整理的開始。",
"你會走出去的，一步一步就會。",
"今天先讓自己好好睡一覺，明天再戰。"
];
